/* 
Get if customer is: 
Signed out - New - Guest user or not logged in
Signed in - New - Logged-in user with 0 orders
Signed in - Returning - Logged-in user with one or more orders
*/

import { useSelector } from "react-redux";

const useNewOrReturningCustomer = () => {
  const userState = useSelector((state) => state.loginUser);

  let newOrReturningCustomer = null;

  if (userState) {
    // When user is not logged in
    if (userState.user_loggedIn === false) {
      newOrReturningCustomer = "Signed out - New";
    }
    // When user is logged in
    else if (userState.userData) {
      // If user has one or more orders, they are a returning customer
      if (userState.userData.orders.edges.length > 0) {
        newOrReturningCustomer = "Signed in - Returning";
      } else {
        // If no orders, they are a new customer
        newOrReturningCustomer = "Signed in - New";
      }
    }
  }

  return newOrReturningCustomer;
};

export default useNewOrReturningCustomer;